import { render, staticRenderFns } from "./OverdueOrdersList.vue?vue&type=template&id=285ed274"
import script from "./OverdueOrdersList.vue?vue&type=script&lang=js"
export * from "./OverdueOrdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports